import { useEffect, useState, useCallback } from 'react';
import { Table, Button, Badge, Spinner, Alert } from 'react-bootstrap';
import { api } from '../api/client';
import { AddBookingModal } from './ManageBookings';
import { formatDateTime } from '../shared/dateFormat';

const BADGE = { demo_scheduled: 'warning', demo_completed: 'info', hired: 'success', rejected: 'secondary', cancelled: 'secondary' };

export default function AdminManageDemos() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [showAdd, setShowAdd] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const all = await api.get('/admin/bookings');
      setRows(all.filter((b) => b.status.startsWith('demo') || b.status === 'hired' || b.status === 'rejected'));
    } catch (e) { setErr(e.message); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="text-center py-5"><Spinner /></div>;
  if (err) return <Alert variant="danger">{err}</Alert>;

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Demos</h3>
        <Button onClick={() => setShowAdd(true)}>+ Add Demo</Button>
      </div>
      <Table bordered hover responsive className="bg-white">
        <thead className="table-dark"><tr><th>#</th><th>Student</th><th>Teacher</th><th>Slot</th><th>Amount held</th><th>Status</th></tr></thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={6} className="text-center text-muted">No demos yet</td></tr>}
          {rows.map((b) => (
            <tr key={b.id}>
              <td>{b.id}</td><td>{b.student_name}</td><td>{b.teacher_name}</td>
              <td>{formatDateTime(b.demo_slot_at)}</td><td>₹{Number(b.amount_held).toFixed(0)}</td>
              <td><Badge bg={BADGE[b.status] || 'secondary'}>{b.status.replace('_', ' ')}</Badge></td>
            </tr>
          ))}
        </tbody>
      </Table>
      {showAdd && <AddBookingModal onClose={() => setShowAdd(false)} onDone={() => { setShowAdd(false); load(); }} />}
    </>
  );
}
